import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";

const LoadingSchedulesContext = React.createContext({});

function LoadingSchedulesContextProvider({
  children,
  defaultLabelLoading = false,
  defaultNotesLoading = true,
  defaultLoadingCodes = true
}) {
  const [labelLoading, setLabelLoading] = useState(defaultLabelLoading);
  const [notesLoading, setNotesLoading] = useState(defaultNotesLoading);
  const [loadingCodes, setLoadingCodes] = useState(defaultLoadingCodes);
  const isLoading = labelLoading || notesLoading || loadingCodes;
  return (
    <LoadingSchedulesContext.Provider
      value={{
        labelLoading,
        setLabelLoading,
        setNotesLoading,
        setLoadingCodes
      }}
    >
      {children}
      {isLoading && (
        <Dimmer active inverted>
          <Loader size="large">Loading</Loader>
        </Dimmer>
      )}
    </LoadingSchedulesContext.Provider>
  );
}

export { LoadingSchedulesContext };

export default withRouter(LoadingSchedulesContextProvider);
